<template>
    <!-- Alert -->
    <!-- to use this component like what shown in below: -->
    <!-- <Alert type="error" :key="uniqid" > ~ </Alert> -->
    <!-- Step1: import that component -->
    <!-- Step2: add that component as our components to our element's components -->
    <!-- Step3: pass type of alert (success, error or warning) and an uniqid as key property (we generate that with uniqid package) -->

    <div class="alert" :class="alertColors" v-show="isShow" role="alert">
        <a @click="close">
            <i class="fa fa-times-circle fa-size" aria-hidden="true"></i>
        </a>
        
        <span>
            <slot></slot>
        </span>
    </div>
</template>

<script>
export default {
    name: 'Alert',
    props: {
        type: String,
        sm: Boolean,
    },
    data() {
        return {
            isShow: true,
            alertColors: {
                'alert-success': this.type == 'success',
                'alert-danger': this.type == 'error',
                'alert-warning': this.type == 'warning'
            }
        };
    },
    methods: {
        close() {
            this.isShow = false;
        }
    }
};
</script>

<style scoped>
.alert {
    position: absolute;
    top: 12pt;
    right: 6pt;
}
.alert a {
    cursor: pointer;
    margin-left: 10pt;
}
</style>
